<template>
  <AgentLayout>
    <div class="w-11/12 max-w-3xl mx-auto space-y-6">
      <div class="flex items-center justify-between gap-3">
        <div>
          <h1 class="text-2xl font-bold leading-7 text-gray-900">Referrals</h1>
          <p class="mt-1 text-sm text-gray-600">
            Help grow {{ team.company || 'the team' }} by referring agents you'd vouch for.
          </p>
        </div>
        <Button @click="sheetOpen = true">
          <Plus class="h-4 w-4 mr-1.5" />
          New referral
        </Button>
      </div>

      <ReferralLinkCard :referral-link="referralLink" />

      <ReferralsList :referrals="referrals" />

      <NewReferralSheet v-model:open="sheetOpen" @created="reload" />
    </div>
  </AgentLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import AgentLayout from '@/components/layouts/AgentLayout/index.vue';
import ReferralLinkCard from '@/components/agent/referrals/ReferralLinkCard.vue';
import ReferralsList from '@/components/agent/referrals/ReferralsList.vue';
import NewReferralSheet from '@/components/agent/referrals/NewReferralSheet.vue';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-vue-next';
import { Api } from '@/api';
import type { AgentReferralEntity } from '@/api/entity_types/AgentReferral';
import { useTeamStore } from '@/stores/team';
import { storeToRefs } from 'pinia';
import { toast } from 'vue-sonner';

const teamStore = useTeamStore();
const { team } = storeToRefs(teamStore);

const referralLink = ref<string | null>(null);
const referrals = ref<AgentReferralEntity[]>([]);
const sheetOpen = ref(false);

const reload = async () => {
  const response = await Api.AgentReferrals.listReferrals();
  if (response.status === 'success') {
    referralLink.value = response.data.referral_link;
    referrals.value = response.data.referrals;
  } else {
    toast.error('Could not load referrals', { description: response.messages.join(', ') });
  }
};

onMounted(reload);
</script>
